import React, { useCallback } from "react"

import AcSearchInput from "components/AcInput/AcSearchInput"

interface SearchInputProps {
    header: string
    value: string
    onChange: (value: string) => void
}

const sxStyles = { flexGrow: 1 }

export const SearchInput: React.FC<SearchInputProps> = React.memo(({
    header,
    value,
    onChange
}) => {
    const handleChange = useCallback(
        (e: any) => onChange(e.target.value),
        [onChange]
    )

    return (
        <AcSearchInput
            size="small"
            header={header}
            onChange={handleChange}
            sx={sxStyles}
            value={value}
            setValue={onChange}
        />
    )
})

SearchInput.displayName = 'SearchInput'

